export const getMenuPosition = ({
  rect,
  yOffset = 0,
  xOffset = 0,
  nubSize = 0,
  isTop = false,
  isBottom = false,
  alignEdge = false,
}) => {
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
  // Due to compatibility problems (see below),
  // it is safest to rely on only properties left, top, right, and bottom.

  // Screen X and Y of target
  const screenCenterX = rect.x + (rect.width / 2)
  const screenCenterY = rect.y + (rect.height / 2)

  // Quadrant of 
  let isBelowFold = screenCenterY / window.innerHeight > 0.5
  const isLeftOfCenter = (screenCenterX / window.innerWidth) < 0.5

  // Center X of target
  let targetCenterX = rect.x + (rect.width / 2);
  if (alignEdge) {
    targetCenterX = isLeftOfCenter ? rect.x : rect.x + rect.width;
  }

  // Force position
  if (isTop) {
    isBelowFold = true
  }
  if (isBottom) {
    isBelowFold = false
  }

  // Expand left or right
  const positionDirectionX = isLeftOfCenter ? -1 : 1
  const positionDirectionY = isBelowFold ? -1 : 1
  const positionYBase = isBelowFold
    ? rect.y
    : rect.y + rect.height

  const menuContentPosition = {
    x: window.pageXOffset + targetCenterX // Center of target
      - (positionDirectionX * xOffset) // Apply offset
      + (positionDirectionX * nubSize), // Adjust for nub
    y: window.pageYOffset + positionYBase // Top of target
      + (positionDirectionY * yOffset) // Apply offset
      + (positionDirectionY * nubSize), // Adjust for nub
    translateY: isBelowFold ? '-100%' : null
  }

  // Expand inwards
  if (!isLeftOfCenter) {
    menuContentPosition.x += (1.3 * nubSize)
    menuContentPosition.translateX = '-100%'
  } else {
    menuContentPosition.x -= nubSize
  }

  return menuContentPosition
}

export const getNubPosition = ({
  rect,
  isTop = false,
  isBottom = false,
}) => {
  const position = {}

  // Screen X and Y of target
  const screenCenterX = rect.x + (rect.width / 2)
  const screenCenterY = rect.y + (rect.height / 2)

  // Quadrant of 
  let isBelowFold = screenCenterY / window.innerHeight > 0.5
  const isLeftOfCenter = (screenCenterX / window.innerWidth) < 0.5

  // Force position
  if (isTop) {
    isBelowFold = true
  }
  if (isBottom) {
    isBelowFold = false
  }

  // Place in corner
  position.isLeft = isLeftOfCenter
  position.isRight = !isLeftOfCenter
  position.isTop = !isBelowFold
  position.isBottom = isBelowFold

  return position
}

export const getZoomRatio = (element) => {
  let result = 1;
  let elem = element;
  while (elem !== null && result === 1) {
    const style = window.getComputedStyle(elem);
    if (style.zoom) {
      result = parseFloat(style.zoom);
    }
    if (elem === document.body) {
      // Not sure why, but Chrome started returning the wrong value '2' for
      // window.getComputedStyle(document.body.parentElement).zoom
      // so let's not consider it
      break;
    }
    elem = elem.parentElement;
  }
  return result;
}

export const getBoundingClientRect = (element) => {
  const rect = element.getBoundingClientRect();
  const zoom = getZoomRatio(element);
  return {
    bottom: rect.bottom * zoom,
    height: rect.height * zoom,
    left: rect.left * zoom,
    right: rect.right * zoom,
    top: rect.top * zoom,
    width: rect.width * zoom,
    x: rect.x,
    y: rect.y,
  };
}
